// Fechas en español de México, cortas y sin drama.
const ZONA = "America/Monterrey";

export function fechaLarga(d = new Date()): string {
  const t = d.toLocaleDateString("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: ZONA,
  });
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function fechaCorta(iso: string): string {
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00-06:00`) : new Date(iso);
  return d.toLocaleDateString("es-MX", { weekday: "short", day: "numeric", month: "short", timeZone: ZONA });
}

export function fechaYHora(iso: string): string {
  return new Date(iso).toLocaleString("es-MX", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    timeZone: ZONA,
  });
}

/** "hace 2 horas", "ayer, 18:40", "lun 7 sep". */
export function relativa(iso: string, ahora = new Date()): string {
  const d = new Date(iso);
  const min = Math.round((ahora.getTime() - d.getTime()) / 60000);
  if (min < 1) return "ahora";
  if (min < 60) return `hace ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24 && d.getDate() === ahora.getDate()) return `hace ${h} ${h === 1 ? "hora" : "horas"}`;
  const ayer = new Date(ahora);
  ayer.setDate(ahora.getDate() - 1);
  if (d.toDateString() === ayer.toDateString())
    return `ayer, ${d.toLocaleTimeString("es-MX", { hour: "numeric", minute: "2-digit", timeZone: ZONA })}`;
  return fechaCorta(iso);
}

export function saludo(d = new Date()): string {
  const h = Number(d.toLocaleTimeString("es-MX", { hour: "numeric", hour12: false, timeZone: ZONA }).split(":")[0]);
  if (h < 12) return "Buenos días";
  if (h < 19) return "Buenas tardes";
  return "Buenas noches";
}

export function primerNombre(nombre: string): string {
  return nombre.trim().split(/\s+/)[0] ?? nombre;
}
